import { ref, reactive, toValue } from "vue";
const drawerStateStore = ref([]);
export function useDraggableState(id) {
  function createState(id2) {
    const state = {
      id: id2,
      dragStart: void 0,
      dragging: false,
      interpolateTo: void 0,
      originX: 0,
      originY: 0,
      lastDraggedX: 0,
      lastDraggedY: 0,
      intermediateDraggedX: 0,
      intermediateDraggedY: 0,
      draggedX: 0,
      draggedY: 0,
      elRect: void 0,
      wrapperRect: void 0
    };
    return reactive(state);
  }
  function addState(id2) {
    const state = createState(id2);
    drawerStateStore.value = [...drawerStateStore.value, state];
    return state;
  }
  function initializeState() {
    let state = drawerStateStore.value.find((entry) => {
      return entry.id === id;
    });
    if (!state) state = addState(toValue(id));
    return state;
  }
  function deleteState() {
    drawerStateStore.value = drawerStateStore.value.filter(
      (x) => x.id !== id
    );
  }
  return {
    initializeState,
    deleteState
  };
}
